import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CreateSaq from "../../components/CreateSaq";
// import CompletedSaqs from "../../components/CompletedSaqs";

import { images } from "../../helpers/images";

// import logo from "../../static/images/tg-logo.svg";

import {
  callApiSaqsFind,
  callApiDownloadSaqPdf,
  callApiUpdateUserPassword,
  callApiGetBusinessIdUsingSubdomain,
  callApiFetchCompanyUserList,
} from "../../services";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { authUserData } from "../../helpers";
import Header from "../../components/Header";
import DeleteConfirmationModal from "../../components/modals/DeleteConfirmationModal";
import BusinessAdminHeader from "../../components/BusinessAdminHeader";

class Completed extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      draftSaqData: null,
      completedSaqData: null,
      deletedId: null,
      showModal: false,
      businessId: null,
      userIds: null,
      subdomain: null,
      userData: null,
    };
  }

  componentDidMount = async () => {
    const hostname = window.location.hostname;

    // Split by dots
    const parts = hostname.split(".");

    // Get the subdomain (first part)
    const subdomain = parts[0];

    this.setState({
      subdomain: subdomain,
    });

    // console.log("subdomain", subdomain);

    // const businessData = await callApiGetBusinessIdUsingSubdomain(subdomain);
    // const usersData = [];

    // console.log("businessData", businessData);

    /* if (businessData && businessData.data && businessData.data.length > 0) {
      const businessUsersData = await callApiFetchCompanyUserList({
        businessId: businessData.data[0]._id,
      });

      if (
        businessUsersData &&
        businessUsersData.data &&
        businessUsersData.data.length > 0
      ) {
        businessUsersData.data.map((v, i) => {
          usersData.push(v._id);
        });
      }

      console.log("usersData", usersData);
    } */

    const userData = authUserData();

    // console.log("useData Dashboard", userData.userId);

    /* const tempPassword = await this.makeTempPassword();
    const userId = userData && userData.userId;
    callApiUpdateUserPassword(userId, { password: tempPassword }).then(
      (resData) => {
        
      }
    ); */

    this.setState({
      userData,
    });

    let saqsApiParam = null;

    // If admin user is on the main "app" subdomain, show all SAQs
    // If admin user is on a specific business subdomain, show only that business's SAQs
    // If business admin, show only their business's SAQs
    if (userData && userData.isAdmin && userData.isAdmin === true && subdomain === "app") {
      saqsApiParam = {}; // Empty query to get all SAQs
    } else {
      saqsApiParam = { subdomain: subdomain }; // Filter by subdomain
    }

    callApiSaqsFind(saqsApiParam)
      .then((res) => {
        // console.log("api res", res);
        if (res.success && res.data && res.data.length > 0) {
          const draftList = res.data.filter((v, i) => {
            return v.status === "draft";
          });

          const completedList = res.data.filter((v, i) => {
            return v.status === "completed";
          });

          // console.log("completedList", completedList);

          this.setState({
            draftSaqData: draftList,
            completedSaqData: completedList,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  onClickDeleteSaq = (saqId) => {
    this.setState(
      {
        deletedId: saqId,
      },
      () => {
        // document.getElementById("btnOpenSaqDeleteConfirmationModal").click();
        this.setState({ showModal: true });
      }
    );
  };

  downloadSaqPdf = (saqId) => {
    callApiDownloadSaqPdf({ saqId: saqId })
      .then((res) => {
        //console.log("res", res);
        fetch(process.env.REACT_APP_API_URL + "/" + res.data).then(
          (response) => {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = res.data;
              a.click();
            });
          }
        );
      })
      .catch((error) => {
        //console.log("Inside saq download... error", error);
      });
  };

  onSelectAction = (type, saqId, saqType) => {
    // console.log("type", type);
    // console.log("saqId", saqId);
    switch (type) {
      case "edit":
        this.props.history.push("/saq-draft/" + saqType + "/" + saqId);
        break;
      case "delete":
        this.onClickDeleteSaq(saqId);
        break;
      /* case "downloadPdf":
        this.downloadSaqPdf(saqId);
        break; */
      default:
        break;
    }
  };

  render() {
    const { history } = this.props;
    const { userData, draftSaqData, completedSaqData, deletedId, showModal } =
      this.state;

    return (
      <div className="cell small-12 medium-10" id="maincontent">
        {userData && !userData.isAdmin && <BusinessAdminHeader />}
        <div id="body-content">
          <div className="grid-x grid-margin-x grid-margin-y">
            <div className="cell small-12 medium-12" id="completedsaqs">
              <div className="module-header">
                <h3>COMPLETED SAQ's</h3>

                {userData && userData.isAdmin && (
                  <Link to={`/control-panel`}>
                    <button className="button nxt-btn">Back</button>
                  </Link>
                )}
              </div>
              <div id="compltedsaqs-table">
                <table>
                  <thead>
                    <tr>
                      <th width="200">Webisite</th>
                      <th>SAQ Type</th>
                      <th>Business</th>
                      <th>User</th>
                      <th width="150">Last Updated</th>
                      <th width="150">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {completedSaqData && completedSaqData.length > 0 ? (
                      completedSaqData
                        .slice(0)
                        .reverse()
                        .map((v, i) => {
                          return (
                            <tr key={uuidv4()}>
                              <td>{v.domain}</td>
                              <td>{v.type}</td>
                              <td>
                                {v.businessData &&
                                  v.businessData.length === 1 &&
                                  v.businessData[0].businessName +
                                    " ( " +
                                    (v.businessData &&
                                      v.businessData.length === 1 &&
                                      v.businessData[0].website) +
                                    ")"}
                              </td>
                              <td>
                                {v.userData &&
                                  v.userData.length === 1 &&
                                  v.userData[0].email}
                              </td>
                              <td>
                                {moment(v.createdAt).format("MMMM Do YYYY")}
                              </td>
                              <td>
                                <select
                                  onChange={(e) =>
                                    this.onSelectAction(
                                      e.target.value,
                                      v._id,
                                      v.type
                                    )
                                  }
                                >
                                  <option>Options</option>
                                  {/* <option value="edit">Edit</option> */}
                                  <option value="delete">Delete</option>
                                  {/* <option value="downloadPdf">
                                    Download PDF
                                  </option> */}
                                </select>
                              </td>
                            </tr>
                          );
                        })
                    ) : (
                      <tr>
                        <td colSpan="3">No records.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <DeleteConfirmationModal
          history={this.props.history}
          deletedId={deletedId}
          showModal={showModal}
          onCloseModal={() => this.onCloseModal()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Completed);
